import { render, staticRenderFns } from "./MyApp.vue?vue&type=template&id=4738b59b"
import script from "./MyApp.vue?vue&type=script&lang=js"
export * from "./MyApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports